import { CommApiInstance } from "Utils/CommApiInstance";


const TcktEvntApi = async (
) => {
    return await CommApiInstance.post(`memb/tckt/evnt`,{
        apiBody: {
        }
    })
    .then((Resp) => Resp.data);
}

export default TcktEvntApi;